package modysy.view

/** Provides color definitions as strings used for rendering */
object Color {
  def rgb(r: Int, g: Int, b: Int) = s"rgb($r, $g, $b)"

  def rgba(r: Int, g: Int, b: Int, a: Double) = s"rgba($r,$g,$b,$a)"

  val White: String = rgb(255, 255, 255)
  val Red: String = rgb(255, 0, 0)
  val Red_Light: String = rgb(255, 128, 128)
  val Red_LightLight: String = rgb(255, 192, 192)
  val Green: String = rgb(0, 255, 0)
  val Green_Light: String = rgb(128, 255, 128)
  val Blue: String = rgb(0, 0, 255)
  val Cyan: String = rgb(0, 255, 255)
  val Magenta: String = rgb(255, 0, 255)
  val Yellow: String = rgb(255, 255, 0)
  val Yellow_Brown: String = rgb(255, 153, 0)
  val Brown: String = rgb(102, 34, 0)
  val Black: String = rgb(0, 0, 0)
  val Grey: String = rgb(66, 66, 66)
  val Gold: String = rgb(230, 230, 0)
  val Lose_Blue: String = rgb(51, 102, 255)
  val Transparent: String = rgba(255, 255, 255, 0.0)
  val all: Seq[String] =
    Seq(White, Red, Green, Blue, Cyan, Magenta, Yellow, Black)
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/view/Color.scala